import React, { useEffect, useState } from 'react'
import { useTheme } from 'styled-components'
import { useGlobal } from '../../../contexts/GlobalContext'
import BsGraphUp from '@meronex/icons/bs/BsGraphUp'
import { MainDropDown } from '../MainDropDown'
import ProfileStatsChart from '../ProfileStatsChart'
import { EmptyActivityIcon } from '../SvgIcons'
import GradientButton from '../GradientButton'
import eventCreatorAvatar from '../../../assets/images/EventCreatorAvatar.png'
import { NOTIFI_TYPE } from '../../../global/const'
import { useCustomWallet } from '../../../contexts/WalletContext'
import { Pagination } from '../Pagination'
import { useNavigate } from 'react-router-dom'

import {
  ActivitySectionContainer,
  ActivitySectionHeader,
  ActivitySectionFilter,
  ActivitySectionBody,
  ActivityTable,
  EventCreatorProfile,
  EventUserProfile,
  FilterWrapper,
  PaginationWrapper
} from './styles'

const ActivitySection = (props) => {
  const {
    handleActiveSection,
    userAddress
  } = props

  const theme = useTheme()
  const navigate = useNavigate()
  const [users, setUsers] = useState([])
  const { invokeServer } = useGlobal()
  const { wallet, getWalletAddressBySessionKey } = useCustomWallet()

  const [history, setHistory] = useState([])
  const [historyRows, setHistoryRows] = useState([])
  const [selectedPeriod, setSelectedPeriod] = useState('0')
  const [methodType, setMethodType] = useState('all')
  const [minValue, setMinValue] = useState(0)
  const [paginationProps, setPaginationProps] = useState({
    page_size: 10,
    current_page: 1
  })

  const filterList = [
    { key: 'all', name: 'ALL' },
    { key: NOTIFI_TYPE.BUY, name: 'BUYS' },
    { key: NOTIFI_TYPE.SALE, name: 'SALES' }
  ]

  const periodList = [
    { id: 0, name: 'One hour', value: '3600' },
    { id: 1, name: '12 hours', value: '43200' },
    { id: 2, name: 'One day', value: '86400' },
    { id: 3, name: 'Last week', value: '604800' },
    { id: 4, name: 'Last 2 weeks', value: '1209600' },
    { id: 5, name: 'Last month', value: '2592000' },
    { id: 6, name: 'Last 2 months', value: '5184000' },
    { id: 7, name: 'Last 6 months', value: '15552000' },
    { id: 8, name: 'Last year', value: '31104000' },
    { id: 9, name: 'All Time', value: '0' }
  ]

  const renderPriceField = (activity) => {
    switch (activity.paymentName) {
      case 'HyperX':
        return (
          <div className="price-div">
            <img src={theme.images.chainTokenIcon} alt='hyperX' />
            <div>{activity.price}</div>
          </div>
        )
      case 'BNB':
        return (
          <div className="price-div">
            <img src={theme.images.binanceTokenIcon} alt='bnb' />
            <div>{activity.price}</div>
          </div>
        )
      case 'BUSD':
        return (
          <div className="price-div">
            <img src={theme.images.binanceUsdIcon} alt='busd' />
            <div>{activity.price}</div>
          </div>
        )
      default:
        return (
          <div className="price-div">
            <div>{activity.price} {activity.paymentName}</div>
          </div>
        )
    }
  }

  const handleChangePage = (pageNumber) => {
    getStatsList(pageNumber, 10)
  }

  useEffect(() => {
    let ac = new AbortController();

    invokeServer('get', `/api/user?all=`)
      .then(r => {
        if (ac.signal.aborted === false) {
          if (r.data.result === 1) {
            setUsers(t => r.data.users);
          }
        }
      })
      .catch(err => {
        console.log(`${err.message}`)
      })
    return () => ac.abort();
  }, [])

  const renderItemField = (tt) => {
    let nftAvatar = tt?.nftImage || eventCreatorAvatar;
    return (
      <EventCreatorProfile>
        <img src={nftAvatar} alt='nft' />
        <div>
          <div className="value" onClick={() => handleOpenItem(tt)}>{tt?.nftTitle || '---'}</div>
        </div>
      </EventCreatorProfile>
    )
  }

  const handleOpenItem = (item) => {
    navigate(`/products/${item.collectionAddress}/${item.nftId}/collection`)
  }

  const renderUser = (address, userName, userAvatar) => {
    return (
      <EventUserProfile>
        <img src={userAvatar || eventCreatorAvatar} alt='nft' />
        <div>
          <div className="value" onClick={() => handleClickAddress(address)}>{userName || '---'}</div>
        </div>
      </EventUserProfile>
    )
  }

  const handleClickAddress = (address) => {
    navigate(`/profile/${address}`)
    handleActiveSection('grid')
  }

  useEffect(() => {
    if (history?.length > 0) {
      setHistoryRows(allRows =>
        history.map(activity => {
          return (
            <tr key={activity._id}>
              <td>{activity.eventType === 0 ? 'Buy' : 'Sale'}</td>
              <td>{renderItemField(activity)}</td>
              <td>{renderPriceField(activity)}</td>
              <td>{activity.quantity}</td>
              <td>{renderUser(activity.from, activity.fromName, activity.fromAvatar)}</td>
              <td>{renderUser(activity.to, activity.toName, activity.toAvatar)}</td>
              <td>{activity.timeSpan}</td>
            </tr>
          )
        })
      )
    } else {
      setHistoryRows(t => [])
    }
  }, [history])

  useEffect(() => {
    getStatsList(paginationProps.current_page, 10);
  }, [methodType])

  const getStatsList = (page, page_size) => {
    let params = `address=${wallet.address}&period=${selectedPeriod}&page=${page}&page_size=${page_size}`
    if (methodType !== 'all') params = `${params}&method=${methodType}`
    
    invokeServer('get', `/api/trade?${params}`)
      .then(r => {
        if (r.data.items !== undefined && JSON.stringify(r.data.items) !== JSON.stringify(history)) {
          setHistory(t => r.data.items);
          setPaginationProps(r.data.pagination)
          setMinValue(r.data.min)
        }
      })
      .catch(err => {
        console.log(`${err.message}`);
      })
  }

  return (
    <ActivitySectionContainer>
      <ActivitySectionHeader>
        <BsGraphUp />
        <div className="header-text">Activity</div>
      </ActivitySectionHeader>
      <ActivitySectionFilter>
        <MainDropDown
          dataList={periodList}
          initialValue="0"
          selectedPeriod={selectedPeriod}
          setSelectedPeriod={setSelectedPeriod}
        />
        <FilterWrapper>
          {filterList.map(item => (
            <GradientButton
              key={item.key}
              isNoPadding
              width='100px'
              height='40px'
              label={item.name}
              isBlackMode={methodType !== item.key}
              isDarkMode={methodType !== item.key}
              handleClick={() => setMethodType(item.key)}
            />
          ))}
        </FilterWrapper>
      </ActivitySectionFilter>
      <ActivitySectionBody>
        <ProfileStatsChart
          period={parseInt(selectedPeriod)}
          filterValue={methodType}
          history={history}
          minValue={minValue}
        />
        <ActivityTable>
          <table>
            <thead>
              <tr>
                <th>Event</th>
                <th>Item</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>From</th>
                <th>To</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {historyRows.length > 0 ? historyRows : (
                <tr>
                  <td colSpan={8} style={{ paddingTop: '100px' }}>
                    <div className="no-result">
                      <EmptyActivityIcon />
                      <div className="empty-text">There Are No stats Yet</div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </ActivityTable>
      </ActivitySectionBody>
      <PaginationWrapper>
          <Pagination
            currentPage={paginationProps?.current_page}
            totalPages={paginationProps?.total_pages}
            totalItems={paginationProps?.total}
            handleChangePage={handleChangePage}
          />
        </PaginationWrapper>
    </ActivitySectionContainer>
  )
}

export default ActivitySection;
